import { __assign, __rest } from "tslib";
import React from 'react';
import VeltTranscriptionCopyLinkButtonWireframe from './VeltTranscriptionCopyLinkButtonWireframe/VeltTranscriptionCopyLinkButtonWireframe';
import VeltTranscriptionCopyLinkTooltipWireframe from './VeltTranscriptionCopyLinkTooltipWireframe/VeltTranscriptionCopyLinkTooltipWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltTranscriptionCopyLinkWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-copy-link-wireframe", __assign({}, transformedProps), children));
};
VeltTranscriptionCopyLinkWireframe.Button = VeltTranscriptionCopyLinkButtonWireframe;
VeltTranscriptionCopyLinkWireframe.Tooltip = VeltTranscriptionCopyLinkTooltipWireframe;
export default VeltTranscriptionCopyLinkWireframe;
